import {useProduct} from '@salesforce/commerce-sdk-react'
import {
    useProductAvailability,
    QUICK_ADD_AVAILABILITY_STALE_TIME
} from '../../../hooks/use-product-availability'
import {getMasterIdFromHit} from '../utils/product-tile-utils'

// Warms the two queries the quick view runs on open, with its exact keys, once the tile nears the
// viewport. Keyed on the selected colour, so a swatch change fetches that colour's document; the
// master-level availability already covers every colour. The document waits for the enriched hit
// (imageGroups), which is what decides the quick view's `expand` and therefore its key.
const useQuickAddPrefetch = ({product, productId, enabled}) => {
    const hasHitImages = Array.isArray(product?.imageGroups) && product.imageGroups.length > 0
    const masterId = getMasterIdFromHit(product)

    useProduct(
        {parameters: {id: productId, expand: ['variations']}},
        {enabled: enabled && hasHitImages && Boolean(productId)}
    )

    useProductAvailability(masterId, {
        expandVariations: true,
        enabled: enabled && Boolean(masterId),
        staleTime: QUICK_ADD_AVAILABILITY_STALE_TIME
    })
}

export default useQuickAddPrefetch
